import Store from '@get-bridge/learn-legacy-shared/dist/core/Store'
import PerformSettingsPayload from '../schemas/PerformSettingsPayload';
import getPerformSettings from '../data_requests/getPerformSettings';
import { FetchStatus } from '../../constants';
import defaultPayload from '../shared/defaultPayload';
import isFeatureEnabled from '@get-bridge/learn-legacy-shared/dist/utils/isFeatureEnabled';
import Runtime from '@get-bridge/learn-legacy-shared/dist/core/Runtime';

const PerformSettingsStore = Store({
  schema: PerformSettingsPayload,

  initialize() {
    this.fetchStatus = FetchStatus.UNSENT;
  },

  getAll() {
    if (!isFeatureEnabled('perform_goals_okr_in_nav')) return defaultPayload

    const cached = this.cache.getCollection({})[0];
    return (cached && cached.settings) || defaultPayload;
  },

  fetchAll() {
    if (!isFeatureEnabled('perform_goals_okr_in_nav')) {
      this.fetchStatus = FetchStatus.DONE;
      return Promise.resolve()
    }

    this.fetchStatus = FetchStatus.LOADING;

    return getPerformSettings().then(
      (settings) => {
        this.fetchStatus = FetchStatus.DONE;
        this.cache.setCollection({}, [{
          id: 'perform-settings',
          settings,
        }]);

        return settings;
      },
      (error) => {
        this.fetchStatus = FetchStatus.ERROR;
        this.emitChange();
        throw error;
      }
    );
  },
});

export default PerformSettingsStore;



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/perform_settings/stores/performSettingsStore.js